<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="gradiente">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ "Historial del comunicado "+notice.title }}</v-toolbar-title>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh;" class="scrollDesign">
          <v-layout row wrap>
            <v-flex xs12 sm12 xl12 style="max-height: 85vh;" class="scrollDesign">
              <v-timeline>
                <v-timeline-item v-for="n in history" :key="n.id" small>
                  <template v-slot:icon>
                    <v-avatar>
                      <img
                        v-if="n.employee.img != '' && n.employee.img != null"
                        :src="'data:image/jpg;base64, ' + n.employee.img"
                      />
                      <v-icon v-else>person</v-icon>
                    </v-avatar>
                  </template>
                  <template v-slot:opposite>
                    <span v-if="history">{{ n.employee.firstName +" "+ n.employee.lastName}}</span>
                  </template>
                  <v-card class="elevation-2 grey lighten-3">
                    <v-card-title
                      :class="!$vuetify.breakpoint.xsOnly ? 'headline' : ''"
                      v-if="history"
                    >{{ n.dateUpdated | dateFormat2 }}</v-card-title>
                    <v-card-text v-if="history">{{ n.description }}</v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  props: ["value", "notice"],
  data: () => {
    return {
      history: []
    };
  },

  watch: {
    value() {
      if (this.value && this.notice) {
        this.getHistory();
      }
    }
  },
  filters: {
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  methods: {
    getHistory() {
      this.$store
        .dispatch("notice/getNoticeHistory", this.notice.id)
        .then(response => {
          console.log(response);
          this.history = response.data.entity;
          this.$forceUpdate();
        })
        .catch(error => {
          this.toast.failed = true;
          console.log(error);
        });
    },
    close() {
      this.$emit("input", !this.value);
    }
  }
};
</script>

<style>
</style>
